import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const CustomerContext = createContext(null);

export const startGoogleLogin = () => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/app";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const CustomerProvider = ({ children }) => {
  const [customer, setCustomer] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/customer/auth/me");
      setCustomer(data);
    } catch {
      setCustomer(false);
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) return;
    refresh();
  }, [refresh]);

  const logout = async () => {
    await api.post("/customer/auth/logout").catch(() => {});
    setCustomer(false);
  };

  return <CustomerContext.Provider value={{ customer, setCustomer, refresh, logout }}>{children}</CustomerContext.Provider>;
};

export const useCustomer = () => useContext(CustomerContext);
